module.exports = __webpack_public_path__ + "img/gb6172-86__________m16_m16_____.prt.2246f590.jpg";